import progress from "./progress";
import home from "./home";
import athletes from "./athletes/athletes";
import athlete from "./athletes/athlete";
import measurements from "./athletes/measurements";
import exercise from "./athletes/exercise";
import questionnaire from "./athletes/questionnaire";
import app from "./athletes/app";
import files from "./athletes/files";
import profile from "./profile/profile";
import passcode from "./profile/passcode";
import printTemplates from "./profile/printTemplates";
import questionnaires from "./profile/questionnaires";
import connectedAgents from "./profile/connectedAgents";
import notes from "./dietplans/notes";
import recipes from "./dietplans/recipes";
import smartPrompts from "./smartPrompts";

export default{
    progress,
    home,
    athletes,
    athlete,
    measurements,
    exercise,
    questionnaire,
    app,
    files,
    profile,
    passcode,
    printTemplates,
    questionnaires,
    connectedAgents,
    notes,
    recipes,
    smartPrompts,
}